import React from 'react';
import Ingredient from '../presentational/Ingredient';
import data from '../../core/data';

const IngredientsContainer = (props) => {
  const ingredients = data.index.ingredients;
  return (
    <section id="ingredients">
      <div className="container">
        <h1 className="header">What is in the Herbal Aktiv Peel</h1>
        <Ingredient herb={ ingredients.spirulina } />
        <Ingredient herb={ ingredients.ginseng } />
        <Ingredient herb={ ingredients.fenugreek } />
        <Ingredient herb={ ingredients.marshmallow } />
        <Ingredient herb={ ingredients.calendula } />
        <Ingredient herb={ ingredients.chamomile } />
        <Ingredient herb={ ingredients.pansy } />
        <Ingredient herb={ ingredients.largeLeafLinden } />
        <Ingredient herb={ ingredients.lemonBalm } />
        <Ingredient herb={ ingredients.lungwort } />
        <Ingredient herb={ ingredients.fieldHorsetail } />
        <Ingredient herb={ ingredients.sage } />
        <Ingredient herb={ ingredients.witchHazel } />
        <Ingredient herb={ ingredients.ribwortPlantain } />
      </div>
    </section>
  )
}

export default IngredientsContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/IngredientsContainer.jsx
 **/